import { render, staticRenderFns } from "./TableViewBlock.vue?vue&type=template&id=0d5366e8&scoped=true&"
import script from "./TableViewBlock.vue?vue&type=script&lang=js&"
export * from "./TableViewBlock.vue?vue&type=script&lang=js&"
import style0 from "./TableViewBlock.vue?vue&type=style&index=0&id=0d5366e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5366e8",
  null
  
)

export default component.exports